
import { Link } from "react-router-dom";
import { Home, Search } from "lucide-react";
import { useTranslation } from "react-i18next";
import PageHero from "@/components/layout/PageHero";

const NotFoundContent = () => {
  const { t } = useTranslation('notFound');
  
  return (
    <div className="bg-brand-mist">
      <PageHero title="404" description={t('title')} contentClassName="py-12 md:py-16" />
      <div className="container mx-auto px-4 py-12 md:py-16">
        <div className="max-w-lg mx-auto rounded-md border border-brand-cloud bg-white p-8 text-center shadow-sm">
          <p className="text-brand-slate mb-8">
            {t('description')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="flex items-center justify-center rounded-md bg-brand-ink px-6 py-3 font-medium text-white transition-colors hover:bg-brand-charcoal"
            >
              <Home className="h-5 w-5 mr-2" />
              {t('goHome')}
            </Link>
            <Link
              to="/explore"
              className="flex items-center justify-center rounded-md border border-brand-cloud bg-white px-6 py-3 font-medium text-brand-ink transition-colors hover:bg-brand-cloud"
            >
              <Search className="h-5 w-5 mr-2" />
              {t('browseServices')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundContent;
